import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import { Overlay } from 'ol';

/* Ol Map */
import MapView from './MapView';

import { mapSource } from '../../config';

import {
  BluePoint,
} from './images/';

import {
  getColorFromCarClass,
  getYPopupOffset,
  getIconType,
} from './pureHelperFunctions';


import './Map.scss'

@observer
class Map extends Component {
  state = {
    center: [30.6035, 50.4548],
    zoom: 11,
    map: null,
    carInfoPopup: [],
    carsSourceId: 'carsMarkers',
    searchSourceId: 'searchMarkers',
    routeSourceId: 'routeLayer',
    routePointsSourceId: 'routePointsLayer',
    mapView: new MapView(),
  };

  carInfoPopup = React.createRef();
  mapView = this.state.mapView;

  componentDidMount() {
    this.props.getCars()

    const { map } = this.state.mapView.createMapWithFeatureLayer(
      'map__source',
      mapSource,
      this.state.center,
      this.state.zoom,
      this.state.carsSourceId,
      true,
    );

    // Слой для маркера поиска
    this.mapView.createNewFeatureLayer(this.state.searchSourceId, false);

    // Слой для маршрута
    this.mapView.createNewFeatureLayer(this.state.routeSourceId, false);

    // Cлой куда мы положим точки маршрута.
    this.mapView.createNewFeatureLayer(this.state.routePointsSourceId, false);

    /**
     * Подписка на клик по карте
     */
    map.on('click', this.handleFeatureClick);
    /**
     * Записываем ссылку на vectorSource которая будет позже использоваться для
     * Добавления / удаления маркеров автомобилей.
     */
    this.setState(() => ({ map }));
  }

  componentDidUpdate(prevProps) {
    const { carsList, showCars, pointsCoords, routeX, routeY } = this.props;
    const { carsSourceId, routePointsSourceId, routeSourceId } = this.state;
    // Если на карте еще нет маркеров нужно их установить:
    // Функция проверит и установит маркеры если их еще нет на карте
    if (!this.mapView.carsFeaturesExist()) {
      this.mapView.addAllCarsFeatures(carsList, carsSourceId);
    }
    if(prevProps.showCars !== showCars){
      this.state.mapView.updateCarMarkerFilters('callsign_status', this.state.carsSourceId, showCars === null ? [] : [showCars])
    }
    // Класс карты сам проверит нужно ли вносить изменения:
    this.state.mapView.updateCarsMarkers(carsList, carsSourceId)

    // ====== Маршрут
    // Далее устанавливаем новые маркеры.
    this.mapView.clearSourceFromAllMarkers(routePointsSourceId)
    this.displayRouteMarkers(pointsCoords)
    // отображаем маршрут, если он есть
    this.mapView.displayRoute(routeX, routeY, routeSourceId);
  }


  /**
   * Метод отображает маркеры поиска на карте.
   * @param  {Array<Array<number>>} routePoints точки маршрута [[lat, lng], [lat, lng]]
   */
  displayRouteMarkers = routePoints => {
    routePoints.forEach((point) /* : Array<number> */ => {
      // Если координата не пустой массив
      if (point.length) {
        const pointId = JSON.stringify(point);
        this.mapView.addMarkerToSource(
          point,
          this.state.routePointsSourceId,
          BluePoint,
          pointId,
        );
      }
    });
  };

  /**
   * Метод создает строки для popup
   * @param  {Object | null} destination
   * @return {Array<string> | null} - возвращает массив со строками для popup или null
   * если в функцию был передан null или у destination нет адреса
   */
  getPopupTextFromDestination = destination => {
    let addressString;
    let addressString1;
    if (destination) {
      // Это может быть address (не обязательный) | point (обязательный)
      if (destination.address) {
        // Все поля внутри адреса не обязательные, соберем их в 2 строки.
        // Если есть POI то первой строкой будет POI
        const {
          city,
          citydistrict,
          street,
          building,
          poi,
        } = destination.address;
        if (poi) {
          addressString = `${poi}`;
        } else {
          addressString = `${street || ''} ${street ? building || '' : ''}`;
        }

        if (poi) {
          addressString1 = `${city || ''} ${street || ''}, ${
            street ? building || '' : ''
          }`;
        } else {
          addressString1 = `${city || ''} ${citydistrict || ''}`;
        }
      }
    }
    if (addressString && addressString1) {
      return [addressString, addressString1];
    }
    return null;
  };

  compareObjects = (object1, object2) =>
    JSON.stringify(object1) === JSON.stringify(object2) || false;

  /**
   * Функция генерит попап из объекта авто,
   * добавляет его в DOM и возвращает его.
   * @param  {string} id // равно позывному авто для которого генерится popup
   * @param  {Object} carObject // Объект позиции автомобиля, который приходит по api
   * @param  {HTMLElement} // container
   * @return {HTMLElement} // возвращает HTML элемент попапа
   */
  createPopup = (id, carObject) => {
    const { car_class, brand, color } = carObject.car;
    let carClassName = ''
    if(car_class === 2){
      carClassName = 'Стандарт'
    } else if(car_class === 1){
      carClassName = 'Бизнес'
    } else if(car_class === 5){
      carClassName = 'Премиум'
    }
    
    const backgroundColor = {
      backgroundColor: getColorFromCarClass(car_class),
    };
    const elementId = `popup-${id}`;
    const newPopup = (
      <div id={elementId} ref={this.carInfoPopup} className="map-car-popup">
        <div className={`map-car-popup__arrow map-car-popup__arrow--${car_class}`} />
        <div className="map-car-popup__callsign" style={backgroundColor}>
          <div className="map-car-popup__callsign--text">{carClassName}</div>
          {brand} {color}
        </div>
      </div>
    );
    this.setState(() => ({ carInfoPopup: newPopup }));
    return this.carInfoPopup.current;
  };

  /**
   * Обработчик клика по карте, делает следующую логику:
   * 1. Находит маркеры (feature) по которым происходит клик,
   * 2. Если под кликом нет feature значит их или нет на карте, или клик был не по feature => очищаем карту от маркеров
   * 3. Если клик был по маркеру то получает его id и если overlay с таким id уже есть то очищаем карту
   *    т.е. второй клик по маркеру убирает попап
   * 4. Если клик по маркеру и маркера с таким id еще нет то создает новый overlay
   * 5. Добавляет overlay на карту.
   * @param  {Object} event событие
   */
  handleFeatureClick = event => {
    const feature = this.state.map.forEachFeatureAtPixel(
      event.pixel,
      feat => feat,
    );
    if (!feature) {
      // Если клик не на маркер (по карте) то убираем попап
      this.clearMapFromPopupOverlays();
      // Добавил условие что бы маркеры у которых нет позывного не пролетали и не вызывали 404
      // eslint-disable-next-line no-underscore-dangle
    } else if (feature.values_.callsign) {
      const coordinates = feature.getGeometry().getCoordinates();
      const featureId = feature.getId();
      
      // если такой feature уже есть нужно убирать overlay
      const featureIdOverlay = this.state.map.getOverlayById(
        `popup-overlay-${featureId}`,
      );
      if (featureIdOverlay) {
        this.clearMapFromPopupOverlays();
        return;
      }
      const carObject = this.props.carsList.find(
        car => car.callsign === featureId,
      );
      const popup = new Overlay({
        id: `popup-overlay-${featureId}`,
        element: this.createPopup(featureId, carObject),
        positioning: 'bottom-center',
        stopEvent: false,
        offset: [-5, getYPopupOffset(getIconType(this.mapView.mapZoom))],
      });
      popup.setPosition(coordinates);
      this.state.map.addOverlay(popup);
      // Обновляет размеры карты что бы точно позиционировать popup
      this.state.map.updateSize();
    }
  };

  /**
   * Функция очищает карту от попапов
   */
  clearMapFromPopupOverlays = () => {
    const allOverlays = this.state.map.getOverlays();
    if (allOverlays) {
      allOverlays.forEach(overlay => {
        if (overlay) {
          if (/popup-overlay/.test(overlay.getId())) {
            this.state.map.removeOverlay(overlay);
          }
        }
      });
    }
  };



  render() {
    const {
      carInfoPopup,
    } = this.state;


    return (
      <>
        <div id="popups-container" ref={this.popupsContainer}>
          {carInfoPopup}
        </div>
        <div id="map__source" className="map__source">

        </div>
      </>
    );
  }
}

const withData = inject(stores => ({
  carsList: stores.MapStore.carsList,
  showCars: stores.MapStore.showCars,
  fiteredCarsList: stores.MapStore.fiteredCarsList,
  getCars: stores.MapStore.getCars,
  pointsCoords: stores.OrderStore.pointsCoords,
  routeX: stores.OrderStore.routeX,
  routeY: stores.OrderStore.routeY,
}))

export default withData(Map);

